module.exports = __webpack_public_path__ + "static/media/user.2092491a.svg";